import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore }                  from '@store/authStore'
import { ROUTES }                        from '@constants/routes'
import { PageLoader }                    from '@components/feedback/PageLoader'

/**
 * AdminRoute — guards the /admin/* section.
 *
 * Access rules:
 *   - Unauthenticated         → /auth/login (preserves attempted URL in `from`)
 *   - Authenticated non-admin → /portal/dashboard (users may never see /admin/*)
 *   - role === 'super_admin' || 'admin' → render
 */
export function AdminRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isInitializing  = useAuthStore((s) => s.isInitializing)
  const user            = useAuthStore((s) => s.user)
  const location        = useLocation()

  if (isInitializing) return <PageLoader />

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.AUTH.LOGIN} state={{ from: location }} replace />
  }

  // super_admin and admin both have access to the admin console.
  const adminRoles = ['super_admin', 'admin']
  if (!adminRoles.includes(user?.role)) {
    return <Navigate to={ROUTES.PORTAL.DASHBOARD} replace />
  }

  return <Outlet />
}
